import { combineReducers } from 'redux'
import reducers            from './common'

const rootReducer = combineReducers({
    reducer:reducers
})

export default rootReducer;